import React, { Component } from 'react';
import { object, shape, string } from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';

import Address from '../order/address';

class BillShipAddress extends Component {
    render() {
        const { billAddress, shipAddress, className } = this.props;

        return (
            <div className={className}>
                <div>
                    <h4>
                        <FormattedMessage id="billingAddress" defaultMessage="Billing Address" />
                        :
                    </h4>
                    {billAddress && (
                        <Address address={billAddress.attributes} />
                    )}
                </div>
                <div>
                    <h4>
                        <FormattedMessage id="shippingAddress" defaultMessage="Shipping Address" />
                        :
                    </h4>
                    {shipAddress && (
                        <Address address={shipAddress.attributes} />
                    )}
                </div>
            </div>
        );
    }
}

export default injectIntl(BillShipAddress);

BillShipAddress.defaultProps = {
    className: '',
};

BillShipAddress.propTypes = {
    billAddress: shape({
        attributes: shape({
            firstname: string,
            lastname: string,
            address1: string,
            address2: string,
            city: string,
            state_name: string,
            zipcode: string,
            country_name: string,
            phone: string,
        }),
    }).isRequired,
    shipAddress: shape({
        attributes: shape({
            firstname: string,
            lastname: string,
            address1: string,
            address2: string,
            city: string,
            state_name: string,
            zipcode: string,
            country_name: string,
            phone: string,
        }),
    }).isRequired,
    className: string,
};



/** WEBPACK FOOTER **
 ** ./src/components/shared/bill-ship-address.jsx
 **/